import { render, staticRenderFns } from "./ButtonResponseOptionForm.vue?vue&type=template&id=3d5c5c20&scoped=true&"
import script from "./ButtonResponseOptionForm.vue?vue&type=script&lang=js&"
export * from "./ButtonResponseOptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c5c20",
  null
  
)

export default component.exports